import { defineComponent as $, shallowRef as f, useAttrs as k, computed as m, onMounted as C, watch as v, openBlock as g, createBlock as b, normalizeClass as E, withCtx as I, resolveDynamicComponent as T, createCommentVNode as q, nextTick as h } from "vue";
import { IconHelp as H } from "@accor/icons";
import { _ as N } from "../../chunks/index.99cfd0be.js";
import './index.css';const F = /* @__PURE__ */ $({
  name: "AdsIcon",
  __name: "index",
  props: {
    url: {},
    size: { default: 24 },
    text: {},
    color: { default: "text-heading" },
    component: { type: [Function, Object] },
    fallbackUrl: { default: () => H },
    svgAttributes: {},
    fill: { default: "currentColor" }
  },
  setup(t) {
    const a = f(), l = f(), i = k(), w = m(() => ["ads-icon", `ads-icon--${t.size}`, `ads-icon--color-${t.color}`, `ads-icon--fill-${t.fill}`]), y = m(() => {
      var n, r;
      const e = i["aria-label"] || ((n = t.svgAttributes) == null ? void 0 : n["aria-label"]) || i["aria-labelledby"] || ((r = t.svgAttributes) == null ? void 0 : r["aria-labelledby"]);
      return i.ariaHidden ?? !!e ? void 0 : !0;
    }), s = async () => {
      var r;
      if (!t.text)
        return;
      await h();
      const e = (r = a.value) == null ? void 0 : r.$el.querySelector("svg");
      if (!e)
        return;
      let n = e.querySelector("title");
      if (n)
        n.textContent = t.text;
      else {
        n = document.createElement("title");
        const o = document.createTextNode(t.text);
        n.append(o), e.append(n);
      }
    }, x = async () => {
      var n;
      if (await h(), !((n = a.value) != null && n.$el))
        return;
      const e = a.value.$el.querySelector("svg");
      e && (e.setAttribute("width", "1em"), e.setAttribute("height", "1em"), t.svgAttributes && Object.entries(t.svgAttributes).forEach(([r, o]) => {
        (typeof o == "string" || typeof o == "number") && e.setAttribute(r, o.toString());
      }));
    }, A = () => {
      var e;
      (e = a.value) != null && e.$el && l.value && (a.value.$el.innerHTML = "", a.value.$el.append(l.value));
    }, c = async (e) => {
      const n = await fetch(e);
      if (!n.ok)
        throw new Error("[AdsIcon] Icon not found with the provided url");
      const r = await n.text(), d = new DOMParser().parseFromString(r, "image/svg+xml");
      if (d.querySelector("parsererror"))
        throw new Error("[AdsIcon] An error occurred while parsing the icon");
      l.value = d.firstChild;
    }, S = async (e) => {
      try {
        return await c(e);
      } catch {
        return c(t.fallbackUrl);
      }
    };
    C(async () => {
      await u(), await s();
    }), v(
      () => [t.url, t.component],
      () => u()
    ), v(() => [t.text], s);
    const u = async () => {
      !t.url && !t.component ? await c(t.fallbackUrl) : t.url && await S(t.url), A(), await x();
    };
    return (e, n) => (g(), b(N, {
      ref_key: "svgWrapper",
      ref: a,
      as: "span",
      class: E(w.value),
      "aria-hidden": y.value
    }, {
      default: I(() => [
        e.component ? (g(), b(T(e.component), { key: 0 })) : q("", !0)
      ]),
      _: 1
    }, 8, ["class", "aria-hidden"]));
  }
});
export {
  F as AdsIcon
};
